export default __webpack_public_path__ + "static/media/hol_favicon.9e60b41b.ico";